import { type Duration, intervalToDuration } from "date-fns";

/**
 * Starts a countdown tick interval. Returns a cleanup function that must be
 * called to clear the interval (e.g. from a useEffect return).
 */
export function startCountdownInterval(
	endsAt: string | Date,
	onTick: (duration: Duration) => void,
	intervalMs: number,
): () => void {
	const id = setInterval(() => {
		onTick(
			intervalToDuration({
				start: new Date(endsAt),
				end: new Date(),
			}),
		);
	}, intervalMs);

	return () => clearInterval(id);
}
